import { StandaloneSearchBox, useJsApiLoader } from "@react-google-maps/api";
import { FormikProps } from "formik";
import React, { useRef, useState } from "react";
import { checkState } from "../../apis/services/create-service";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "../../utils/config";
import Button from "../Button";
import Input from "../Input";
import MapContainer from "../Map";
import { MainFormType } from "./CreateServiceModal";

interface PickupInformationProps {
  form: FormikProps<MainFormType>;
}

const PickupInformation = ({ form }: PickupInformationProps) => {
  const [isLocationInvalid, setIsLocationInvalid] = useState<boolean | null>(
    null
  );
  const [isVerifyingLocation, setIsVerifyingLocation] = useState(false);

  const handlePickupInformationSubmit = async () => {
    // Validate pickup information fields
    const pickupErrors: any = {};
    const pickupInfo = form.values[form.values.serviceType!].pickupInformation;

    console.log(pickupInfo, "pickupInfo");

    if (!pickupInfo.lat) pickupErrors.lat = "This field is required";
    if (!pickupInfo.lng) pickupErrors.lng = "This field is required";
    if (!pickupInfo.address)
      pickupErrors.address = "Please select a pickup location";

    console.log(pickupErrors, "pickupErrors");

    if (Object.keys(pickupErrors).length === 0) {
      setIsVerifyingLocation(true);
      const res = await checkState(
        form.values[form.values.serviceType!].pickupInformation?.state
      );
      if (res?.success) {
        if (res?.data?.isStateExist) {
          setIsLocationInvalid(false);
          form.setFieldValue("step", "dropoff");
        } else {
          setIsLocationInvalid(true);
        }
      }
      setIsVerifyingLocation(false);

      console.log(res, "REs of state verification");
    } else {
      // Set touched and errors for pickup information fields
      form.setTouched({
        ...form.touched,
        [form.values.serviceType!]: {
          ...form.touched[form.values.serviceType!],
          pickupInformation: {
            lat: true,
            lng: true,
            address: true,
          },
        },
      });

      form.setErrors({
        ...form.errors,
        [form.values.serviceType!]: {
          ...form.errors[form.values.serviceType!],
          pickupInformation: pickupErrors,
        },
      });
    }
  };

  console.log(isLocationInvalid, "is location invalid");

  const values = form.values[form.values.serviceType!].pickupInformation;
  const errors = form.errors[form.values.serviceType!]?.pickupInformation || {};

  const handleFieldChange = (field: string, value: string | number) => {
    form.setFieldValue(
      `${form.values.serviceType}.pickupInformation.${field}`,
      value
    );
  };

  const inputRef = useRef<google.maps.places.SearchBox | null>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY!,
    libraries: GOOGLE_MAPS_LIBRARIES!,
  });

  const handlePlacesChanged = () => {
    const address = inputRef.current?.getPlaces();
    const lat = address?.[0]?.geometry?.location?.lat();
    const lng = address?.[0]?.geometry?.location?.lng();

    const state = address?.[0]?.address_components?.find((comp) =>
      comp?.types?.includes("administrative_area_level_1")
    )?.long_name;

    const country = address?.[0]?.address_components?.find((comp) =>
      comp?.types?.includes("country")
    )?.long_name;

    const city = address?.[0]?.address_components?.find((comp) =>
      comp?.types?.includes("locality")
    )?.long_name;

    handleFieldChange("state", state!);
    handleFieldChange("address", address?.[0]?.formatted_address!);
    handleFieldChange("lat", lat!);
    handleFieldChange("lng", lng!);
    handleFieldChange("city", city!);
    handleFieldChange("country", country!);
  };

  const hasError = errors.address || errors.lat || errors.lng;

  return (
    <div
      className="flex flex-col gap-2"
      onKeyDown={(event) => {
        if (event.key === "Enter") {
        }
      }}
    >
      {isLoaded &&
        (isLocationInvalid === null || isLocationInvalid === false) ? (
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handlePickupInformationSubmit();
            }}
          >
            <p className="text-center text-lg font-semibold">
              Pickup information
            </p>
            <p className="text-center">Please enter pickup address</p>

            <StandaloneSearchBox

              onPlacesChanged={handlePlacesChanged}
              onLoad={(ref) => (inputRef.current = ref)}
            >
              <Input
                value={values.address}
                onChange={(e) => handleFieldChange("address", e.target.value)}
                name="address"
                autoFocus
                label="Pickup location *"
                placeholder="Enter address"
                className='lg:text-[1rem] my-2'
                labelClassName='lg:text-[1rem]'

              />
            </StandaloneSearchBox>
            {values.lat && values.lng && (
              <div className="w-full h-96 mt-4 rounded-xl overflow-hidden">
                <MapContainer
                  zoom={20}
                  handleMapClick={async (event) => {
                    handleFieldChange("lat", event.latLng?.lat()!);
                    handleFieldChange("lng", event.latLng?.lng()!);

                    const geocoder = new window.google.maps.Geocoder();
                    try {
                      const { results } = await geocoder.geocode({
                        location: event.latLng,
                      });

                      if (results[0]) {
                        const state = results[0]?.address_components?.find(
                          (comp) =>
                            comp?.types?.includes("administrative_area_level_1")
                        )?.long_name;

                        const country = results?.[0]?.address_components?.find(
                          (comp) => comp?.types?.includes("country")
                        )?.long_name;

                        const city = results?.[0]?.address_components?.find(
                          (comp) => comp?.types?.includes("locality")
                        )?.long_name;

                        handleFieldChange("state", state!);
                        handleFieldChange(
                          "address",
                          results[0].formatted_address
                        );
                        handleFieldChange("city", city!);
                        handleFieldChange("country", country!);
                      }
                    } catch (error) { }
                  }}
                  latt={values.lat}
                  lngg={values.lng}
                />
              </div>
            )}
            {hasError ? (
              <p className="text-xs text-red-600">
                Please select a pickup location
              </p>
            ) : null}
            <div className="flex justify-center mt-3 md:mr-3">
              <Button
                isLoading={isVerifyingLocation}
                type="submit"
                className="w-full md:w-32 min-h-0 h-10 md:h-10"
                onClick={handlePickupInformationSubmit}
              >
                Continue
              </Button>
            </div>
          </form>
        </>
      ) : (
        <div className="flex flex-col items-center my-10 gap-4">
          <p className="text-primary text-2xl font-bold">Service unavailable</p>
          <p className="font-medium text-center">
            Unfortunately, we don't have any drivers in your area to take your
            order right now.
          </p>
          <p className="text-sm">Please select a different pickup location.</p>
          <Button
            onClick={() => {
              setIsLocationInvalid(null);
            }}
          >
            Change Pickup Location
          </Button>
        </div>
      )}
    </div>
  );
};

export default PickupInformation;
